import React, {CSSProperties, FC} from "react"
import {MarkdownAtom, MarkdownBlock} from "../../model/markdown/MarkdownText"
import {AtomsViewer} from "../atoms/AtomsViewer"
import './MarkdownOrderedList.less'

interface MarkdownOrderedListProps {
    block: MarkdownBlock
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const getIdentStyle = (ident: number): CSSProperties => {
    return {
        marginLeft: ident * 8,
    }
}

export const getSubLists = (block: MarkdownBlock): Array<MarkdownBlock> => {
    const subLists: Array<MarkdownBlock> = []
    if (block.atoms.length > 0) {
        let lastIndent = block.atoms[0].indent
        let curBlock = {
            ...block,
            atoms: [block.atoms[0]]
        }
        for (let i = 1; i < block.atoms.length; i++) {
            const atom = block.atoms[i]
            if (atom.indent === lastIndent) {
                curBlock.atoms.push(atom)
            } else {
                subLists.push(curBlock)
                curBlock = {
                    ...curBlock,
                    atoms: [atom],
                    id: atom.id,
                }
                lastIndent = atom.indent
            }
        }
        subLists.push(curBlock)
    }
    return subLists
}

export const MarkdownOrderedList: FC<MarkdownOrderedListProps> = ({
                                                                      block,
                                                                      onToggleCheckBox
                                                                  }) => {
    const subLists: Array<MarkdownBlock> = getSubLists(block)

    return (
        <>
            {subLists.map((subList) => (
                <div className="block orderedList" key={subList.id}>
                    <ol start={subList.startFrom}>
                        {subList.atoms.map(atom => (
                            <li key={atom.id} style={getIdentStyle(atom.indent)}>
                                <AtomsViewer atoms={atom.subAtoms} onToggleCheckBox={onToggleCheckBox}/>
                            </li>
                        ))}
                    </ol>
                </div>
            ))}
        </>
    )
}
